import glossaryData from './wasteGlossary.json'

export interface GlossaryTerm {
  slug: string
  term: string
  category: string
  definition: string
  practicalNote: string
  related: string[]
}

export const wasteGlossaryTerms = glossaryData as GlossaryTerm[]

export const getGlossaryTerm = (slug: string) => wasteGlossaryTerms.find((term) => term.slug === slug)
